function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M 39.306641 8.7089844 C 39.031945 8.7221262 38.754674 8.7692712 38.478516 8.8535156 L 6.4785156 18.632812 C 5.0111799 19.080681 4 20.448454 4 21.980469 L 4 27.019531 C 4 28.551546 5.0111799 29.919319 6.4785156 30.367188 L 12.207031 32.117188 C 11.794768 35.886516 13.974917 39.560885 17.732422 40.671875 C 21.441616 41.767504 25.213219 39.927277 26.951172 36.623047 L 38.478516 40.146484 L 38.476562 40.144531 C 40.686641 40.820487 43 39.109346 43 36.798828 L 43 12.201172 C 43 10.468283 41.699587 9.0728237 40.117188 8.7675781 C 39.853454 8.7167039 39.581336 8.6958425 39.306641 8.7089844 z M 15.078125 32.994141 L 24.091797 35.75 C 22.908466 37.522538 20.744511 38.433679 18.582031 37.794922 C 16.389921 37.146776 15.069868 35.159784 15.078125 32.994141 z"
});

var SvgMegaphone = function SvgMegaphone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    viewBox: "0 0 48 48",
    width: "24px",
    height: "24px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMegaphone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/megaphone.ca292cb4.svg";
export { ForwardRef as ReactComponent };